/* ═══════════════════════════════════════════════════════════════════════════
   THE SAIGA STUDIO — landing, JavaScript della section Shopify
   ---------------------------------------------------------------------------
   PORTATO DA: 05_landing_page/prototipo/index.html (componente React + Babel).
   Qui non c'e' React, non c'e' Babel, non c'e' nessuna CDN esterna: sono
   CINQUE comportamenti, non un framework —
     1. il carosello "What You'll Make"
     2. la fisarmonica delle FAQ
     3. il filtro delle collezioni + la griglia dei template
     4. la barra fissa che compare allo scroll
     5. il carrello di pre-checkout, che ora parla con la Cart AJAX API di Shopify

   ⛔ IL PEZZO CHE CONTA, ed e' il motivo per cui questo file esiste:
      l'add-to-cart deve valere UNA VOLTA SOLA. Non con un contatore nostro in
      sessionStorage — quello non impedirebbe la seconda chiamata, quindi non
      impedirebbe il secondo evento, e la quantita' andrebbe comunque a 2.
      Si vince in un modo solo: PRIMA si legge /cart.js, e /cart/add.js si chiama
      SOLO se quella variante non c'e' gia'. E' `add.js` che fa scattare
      `add_to_cart` di Shopify: non richiamarlo e' l'unico modo perche' l'evento
      resti uno. Per correggere una quantita' si usa /cart/change.js, che
      IMPOSTA (non somma).

   ⛔ NON si scrive fbq('track','AddToCart') qui dentro, e non e' una svista.
      Col canale Facebook & Instagram di Shopify collegato, Shopify manda gia'
      add_to_cart e checkout_started da solo: un fbq a mano li conterebbe DUE
      volte, e da quel momento il costo per acquisto in Gestione inserzioni e'
      falso. Vedi RESOCONTO-PORT-SHOPIFY.md § tracciamento.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── I numeri del prodotto ────────────────────────────────────────────────
     ⛔ QUESTO BLOCCO NON SI SCRIVE A MANO. Lo copia, VERBATIM,
     05b_backend_vendita/_aggiorna_tema.py dal blocco generato che sta in
     05_landing_page/prototipo/index.html, che a sua volta lo scrive
     05_landing_page/_aggiorna_catalogo.py leggendo `_inventario.json` e
     contando i PDF sul disco.
     La catena e':  prodotto  ->  _aggiorna_catalogo.py  ->  index.html
                              ->  _aggiorna_tema.py      ->  questo file.
     La formula (N // 10) * 10 + "+" vive QUI DENTRO, come nella pagina: se il
     catalogo scendesse a 99 la riga diventerebbe "90+" da sola, e non puo' mai
     promettere piu' di quello che c'e' nello ZIP.
     Se rilanci _aggiorna_catalogo.py, rilancia POI _aggiorna_tema.py. */
  function datiProdotto() {
    // ⇩⇩ GENERATO DA _aggiorna_catalogo.py — NON SCRIVERE QUESTI NUMERI A MANO ⇩⇩
    // Lo scrive `05_landing_page/_aggiorna_catalogo.py` leggendo
    // `04b_costruzione_prodotto/_inventario.json` e contando i PDF sul disco.
    // Se il prodotto cambia si rilancia lo script (poi `_sincronizza.py`) e la
    // pagina si riallinea da sola: e' l'unico punto in cui questi numeri esistono.
    const PRODOTTO = { designs: 101, pdf: 1010, colourPlans: 101, collezioni: 7 };

    // ⛔ In pagina NON si scrive mai il totale esatto dei design: si scrive la
    // decina PIENA sotto il totale. 101 -> "100+". Cosi' la riga commerciale non
    // puo' MAI promettere piu' di quello che c'e' dentro lo ZIP.
    const nDesign     = `${Math.floor(PRODOTTO.designs / 10) * 10}+`;
    // I PDF invece sono un conteggio di file, non una riga commerciale: esatto.
    const nPdf        = PRODOTTO.pdf.toLocaleString('en-US');
    const nCollezioni = String(PRODOTTO.collezioni);

    // 8 card per collezione (4 colonne x 2 righe), prese a passo regolare dal
    // design piu' facile al piu' difficile: la vetrina mostra tutta l'escursione.
    const catalogue = {
      "Beginner": [{n:"Apple",d:1,p:5}, {n:"Sunset",d:1,p:5}, {n:"Cat Under the Moon",d:1,p:10}, {n:"Tree Swing",d:1,p:11}, {n:"Rainbow",d:1,p:12}, {n:"Hot Air Balloon",d:1,p:15}, {n:"Sailboat",d:2,p:23}],
      "Blooms": [{n:"Plumeria",d:1,p:11}, {n:"Phalaenopsis Orchid",d:1,p:17}, {n:"Orchid Bloom",d:1,p:19}, {n:"Tulip",d:1,p:19}, {n:"Camellia",d:2,p:23}, {n:"Rose",d:2,p:23}, {n:"Lotus",d:2,p:26}, {n:"Daisy",d:2,p:30}],
      "Flowers & Cottage": [{n:"Heart Flower",d:1,p:18}, {n:"Butterfly & Flower",d:2,p:23}, {n:"Tulip Bouquet",d:2,p:25}, {n:"Watering Can Flowers",d:3,p:36}, {n:"Flower Wheelbarrow",d:3,p:38}, {n:"Tulips",d:3,p:39}, {n:"Sunflower Pot",d:3,p:42}, {n:"Flower Basket",d:3,p:61}],
      "Landscapes": [{n:"Desert Mesa",d:1,p:11}, {n:"Mountain Range",d:1,p:13}, {n:"Hoodoo Landscape",d:1,p:18}, {n:"Waterfall Valley",d:1,p:20}, {n:"Volcanic Mountain",d:2,p:22}, {n:"Layered Valley",d:2,p:26}, {n:"Mountain Forest",d:3,p:35}, {n:"Flying Balloon",d:3,p:48}],
      "Animals": [{n:"Butterfly",d:2,p:24}, {n:"Chicken",d:2,p:30}, {n:"Rabbit",d:2,p:32}, {n:"Cat",d:2,p:34}, {n:"Otter",d:2,p:34}, {n:"Parrot",d:3,p:37}, {n:"Bird",d:3,p:43}, {n:"Hedgehog",d:3,p:44}],
      "Geometric": [{n:"Design11",d:1,p:9}, {n:"Design7",d:1,p:16}, {n:"Diamond Nine Patch",d:1,p:17}, {n:"Design6",d:1,p:20}, {n:"Sawtooth Border",d:2,p:21}, {n:"Pinwheel Star",d:2,p:25}, {n:"Dahlia",d:2,p:33}, {n:"Star Wheel",d:3,p:37}],
      "Christmas": [{n:"Christmas Stocking",d:1,p:15}, {n:"Christmas Star",d:1,p:17}, {n:"Christmas Bow",d:2,p:29}, {n:"Christmas Tree",d:2,p:31}, {n:"Christmas Pine Forest",d:3,p:36}, {n:"Christmas Gift Box",d:3,p:37}, {n:"Christmas Wreath",d:3,p:37}, {n:"Christmas Bells",d:3,p:39}],
    };
    // ⇧⇧ FINE BLOCCO GENERATO ⇧⇧
    return { PRODOTTO, nDesign, nPdf, nCollezioni, catalogue };
  }

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ══ 1. IL CAROSELLO ═══════════════════════════════════════════════════════
     Tre trappole gia' pagate una volta, e stanno tutte qui:
      1. il passo del giro si misura DAL DOM. `scrollWidth / COPIE` sbaglia di
         qualche pixel per via del padding del binario, e a ogni giro si vedeva
         un piccolo scatto.
      2. `scrollLeft` non e' affidabile sotto il pixel: la posizione vera la
         tiene lo script in `pos`. Se fra un frame e l'altro `scrollLeft` si
         sposta da solo, ha scrollato l'utente: allora e' `pos` che si riallinea.
      3. il riavvolgimento va fatto PRIMA del fondo corsa: oltre
         `scrollWidth - clientWidth` il browser tronca e il carosello si pianta.
     Con prefers-reduced-motion il moto automatico non parte mai; fuori schermo
     il rAF si ferma. */
  function montaCarosello(track, ctx) {
    if (!track || !track.children.length) return;

    const COPIE = 5;          // quante volte la lista e' ripetuta nel DOM
    const VELOCITA = 0.042;   // px al millisecondo, cioe' ~42 px al secondo
    const RIPRESA = 1400;     // quiete richiesta prima che riparta da solo

    let pos = 0, scritto = 0, ultimo = 0, fermoFino = 0, trascina = null, visibile = true;
    const calmo = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const perCopia = track.children.length / COPIE;
    const unita = () => {
      const primo = track.children[0], dopo = track.children[perCopia];
      return dopo ? dopo.offsetLeft - primo.offsetLeft : 0;
    };

    const riavvolgi = () => {
      const u = unita();
      if (!u) return;
      const fondo = Math.min(u * 2, track.scrollWidth - track.clientWidth);
      let d = 0;
      if (pos >= fondo) d = -u;
      else if (pos <= 1) d = u;
      if (d) { pos += d; if (trascina) trascina.pos += d; }
    };

    const pausa = () => { fermoFino = performance.now() + RIPRESA; };

    const passo = (t) => {
      ctx.raf = requestAnimationFrame(passo);
      const dt = ultimo ? Math.min(t - ultimo, 64) : 0;
      ultimo = t;
      if (Math.abs(track.scrollLeft - scritto) > 1.5) pos = track.scrollLeft;
      const inPausa = calmo || trascina || t < fermoFino || document.hidden || !visibile;
      if (!inPausa) pos += VELOCITA * dt;
      riavvolgi();
      track.scrollLeft = pos;
      scritto = track.scrollLeft;
    };

    const avvia = () => {
      const u = unita();
      if (!u) { requestAnimationFrame(avvia); return; }
      pos = u;                       // si parte dalla copia di mezzo
      track.scrollLeft = pos;
      scritto = track.scrollLeft;
      ctx.raf = requestAnimationFrame(passo);
    };
    avvia();

    // il dito e la rotella: lo scorrimento lo fa il browser, qui si mette in pausa
    ['wheel', 'touchstart', 'touchmove', 'touchend', 'keydown'].forEach((ev) => {
      track.addEventListener(ev, pausa, { passive: true });
    });

    // il mouse: qui il trascinamento va fatto a mano
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType && e.pointerType !== 'mouse') { pausa(); return; }
      trascina = { x: e.clientX, pos };
      track.classList.add('k-grab');
      try { track.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault();
    });
    track.addEventListener('pointermove', (e) => {
      if (!trascina) return;
      pos = trascina.pos - (e.clientX - trascina.x);
      riavvolgi();
      track.scrollLeft = pos;
      scritto = track.scrollLeft;
    });
    const molla = (e) => {
      if (!trascina) return;
      trascina = null;
      track.classList.remove('k-grab');
      try { track.releasePointerCapture(e.pointerId); } catch (_) {}
      pausa();
    };
    ['pointerup', 'pointercancel'].forEach((ev) => track.addEventListener(ev, molla));

    if (typeof IntersectionObserver !== 'undefined') {
      ctx.osserva = new IntersectionObserver(
        (voci) => voci.forEach((v) => { visibile = v.isIntersecting; }),
        { rootMargin: '120px' });
      ctx.osserva.observe(track);
    }
  }

  /* ══ 2. IL CARRELLO — Cart AJAX API di Shopify ═════════════════════════════
     /cart/add.js e /cart/change.js vogliono Content-Type: application/json e
     rispondono col carrello aggiornato: la risposta si USA per ridisegnare i
     totali, non si ricalcola niente a mano.
     Se una chiamata fallisce (rete, prodotto esaurito, variante inesistente)
     la pagina lo DICE e NON manda al checkout. ⛔ Mai fingere che sia andata bene. */
  /* ══ 2bis. IL POPUP EMAIL ═════════════════════════════════════════════════
     ⛔ Ogni accesso a localStorage sta in try/catch: in incognito, o con i dati
        dei siti bloccati, LEGGERE gia' lancia. Un popup che esplode al primo
        accesso e' una pagina che non parte.  */
  const MEM = {
    leggi(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    scrivi(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  const K_CHIUSO = 'sg_pop_chiuso';   // quando l'ha chiuso, in ms
  const K_LEAD   = 'sg_lead';         // l'uuid restituito da /lead
  const K_CODICE = 'sg_lead_code';
  const GIORNI30 = 30 * 24 * 3600 * 1000;

  /* "Questo iscritto ha roba nel carrello". Parte solo per chi ha gia' lasciato
     l'email: senza indirizzo non c'e' nessuno a cui scrivere.
     ⛔ Non blocca e non riporta errori: e' un avviso al server, non un passaggio
        dell'acquisto. Se fallisce, il cliente non deve accorgersene. */
  let pingFatto = false;
  function pingCarrello(cfg, carrello) {
    if (pingFatto) return;
    const lead = MEM.leggi(K_LEAD);
    if (!lead || !carrello || !carrello.items || !carrello.items.length) return;
    const url = ((cfg.popup && cfg.popup.endpoint) || '') .replace(/\/lead$/, '/lead/cart');
    if (!url) return;
    pingFatto = true;
    try {
      fetch(url, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({
          lead,
          items: carrello.items.map((i) => ({ id: String(i.variant_id), q: i.quantity }))
        })
      }).catch(() => {});
    } catch (e) {}
  }

  function creaCarrello(root, cfg) {
    const wrap  = root.querySelector('[data-saiga-cart]');
    const errEl = root.querySelector('[data-saiga-err]');
    const totEl = root.querySelector('[data-saiga-total]');
    const goEl  = root.querySelector('[data-saiga-checkout]');
    const bundleEl = root.querySelector('[data-saiga-bundle]');
    const bumpEls  = Array.from(root.querySelectorAll('[data-saiga-bump]'));
    if (!wrap) return null;

    const routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = (p) => (routes.replace(/\/$/, '') + p);

    /* ⛔ 30/08/2026 — LA RETE SOTTO IL LIQUID, e serve davvero.
       Il 30/08 la section ha lasciato passare tre righe di order bump per prodotti
       che non esistono, con `variantId: null`. Qui sotto il codice faceva
       `String(null)` -> "null", che e' una stringa NON vuota, quindi TRUTHY: la
       guardia `if (!variantId)` non scattava, si arrivava a `Number("null")` = NaN,
       JSON.stringify lo scriveva come `null` e Shopify rispondeva
       «Required parameter missing or invalid: id» — un errore rosso, in faccia al
       cliente, al primo click su una riga.
       Adesso una variante conta solo se e' un NUMERO INTERO POSITIVO, e la
       configurazione viene ripulita PRIMA di essere usata: da qui in giu' non
       esistono varianti finte, quindi non c'e' piu' niente da ricordarsi. */
    const idValido = (v) => {
      const n = Number(v);
      return Number.isSafeInteger(n) && n > 0 ? n : null;
    };
    if (cfg.main && !idValido(cfg.main.variantId)) cfg.main = null;
    if (cfg.bundle && !idValido(cfg.bundle.variantId)) cfg.bundle = null;
    cfg.bumps = (cfg.bumps || []).filter((b) => idValido(b.variantId));

    const scelte = new Set();     // chiavi dei bump spuntati
    let bundleOn = false;
    let occupato = false;
    let ultimoCarrello = null;
    /* Ogni click alza `versioneUI`. Quando una sincronizzazione finisce scrive in
       `versioneSincronizzata` la versione che aveva quando e' partita. Se i due
       numeri coincidono, il totale di Shopify descrive le spunte che si vedono e
       si puo' mostrare quello; se no si mostra il totale calcolato. */
    let versioneUI = 0;
    let versioneSincronizzata = -1;

    /* ⛔ 30/08 (notte) — IL TOTALE SEGUE LA VALUTA DEL MERCATO, NON UN SIMBOLO FISSO.
       Prima si concatenava `cfg.currency` (un simbolo scritto nelle impostazioni) a
       un numero: con Shopify Markets il carrello risponde in DOLLARI CANADESI e la
       pagina avrebbe scritto «€53.90». Adesso il codice valuta arriva da Shopify —
       dal carrello vero quando c'e' (`/cart.js` lo restituisce), altrimenti da
       `cart.currency.iso_code` che la section mette in `cfg.currencyCode` — e la
       formattazione la fa Intl, che sa dove va il simbolo in ogni lingua.
       Il ripiego resta il vecchio comportamento: meglio un simbolo impreciso che
       un totale che non compare. */
    const codiceValuta = () =>
      (ultimoCarrello && ultimoCarrello.currency) || cfg.currencyCode || 'USD';

    const soldi = (cents) => {
      const v = cents / 100;
      const interi = Math.round(v * 100) % 100 === 0;
      const opzioni = {
        style: 'currency',
        currency: codiceValuta(),
        minimumFractionDigits: interi ? 0 : 2,
        maximumFractionDigits: interi ? 0 : 2,
      };
      /* `narrowSymbol` per stare uguale ai prezzi che stampa Liquid: senza, un
         carrello in dollari canadesi scriverebbe «CA$36.90» sotto a righe che
         dicono «$29.90» e «+$7», e sembrerebbe un altro prezzo. Non tutti i
         browser vecchi lo conoscono: se lo rifiutano si riprova senza. */
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined,
          Object.assign({ currencyDisplay: 'narrowSymbol' }, opzioni)).format(v);
      } catch (e) { /* si riprova sotto */ }
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, opzioni).format(v);
      } catch (e) {
        return (cfg.currency || '') + (interi ? String(Math.round(v)) : v.toFixed(2));
      }
    };

    const errore = (msg) => {
      if (!errEl) return;
      if (!msg) { errEl.hidden = true; errEl.textContent = ''; return; }
      errEl.hidden = false;
      errEl.innerHTML = msg;
    };

    const nonConfigurato = () => !cfg.main || !cfg.main.variantId;

    async function chiama(percorso, corpo) {
      const r = await fetch(url(percorso), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(corpo),
      });
      const dati = await r.json().catch(() => null);
      if (!r.ok) {
        const d = (dati && (dati.description || dati.message)) || ('HTTP ' + r.status);
        throw new Error(d);
      }
      return dati;
    }

    async function leggiCarrello() {
      const r = await fetch(url('/cart.js'), { headers: { 'Accept': 'application/json' } });
      if (!r.ok) throw new Error('HTTP ' + r.status + ' su /cart.js');
      ultimoCarrello = await r.json();
      return ultimoCarrello;
    }

    const riga = (carrello, variantId) =>
      (carrello.items || []).find((i) => String(i.variant_id) === String(variantId));

    /* Porta la variante alla quantita' voluta.
       ⛔ add.js SOLO se la riga non c'e'. Se c'e' gia', anche con la quantita'
          sbagliata, si corregge con change.js (che IMPOSTA, non somma): cosi'
          l'evento add_to_cart di Shopify scatta una volta sola per variante. */
    async function porta(carrello, variantId, quantita) {
      // ⛔ `!variantId` NON basta: la Map tiene le chiavi come stringhe, e "null" e
      //    "undefined" sono stringhe non vuote, quindi truthy. Si valida il numero.
      const id = idValido(variantId);
      if (!id) return carrello;
      const r = riga(carrello, id);
      if (!r) {
        if (quantita <= 0) return carrello;
        return await chiama('/cart/add.js', { items: [{ id: id, quantity: quantita }] })
          .then(() => leggiCarrello());
      }
      if (r.quantity === quantita) return carrello;
      return await chiama('/cart/change.js', { id: r.key, quantity: quantita });
    }

    /* Le quantita' che il carrello DEVE avere, date le spunte.
       La regola del pacchetto: con tutti e tre spuntati va dentro il prodotto
       "bundle" (un articolo solo, 24 €) e NON i tre separati a 30 €. Sarebbe
       scorretto fargli pagare 6 € in piu' perche' ha cliccato tre volte. */
    function obiettivo(soloMain) {
      const t = new Map();
      t.set(String(cfg.main.variantId), 1);
      (cfg.bumps || []).forEach((b) => t.set(String(b.variantId), 0));
      if (cfg.bundle) t.set(String(cfg.bundle.variantId), 0);
      if (!soloMain) {
        if (bundleOn && cfg.bundle) t.set(String(cfg.bundle.variantId), 1);
        else (cfg.bumps || []).forEach((b) => { if (scelte.has(b.key)) t.set(String(b.variantId), 1); });
      }
      return t;
    }

    async function sincronizza(soloMain) {
      // Senza prodotto principale non si tocca il carrello: `obiettivo` leggerebbe
      // `cfg.main.variantId` su null. Ci si arriva solo per strade anomale (una riga
      // disegnata senza il principale), ma e' un `if`, non un dibattito.
      if (nonConfigurato()) return ultimoCarrello || (await leggiCarrello());
      let carrello = await leggiCarrello();
      const target = obiettivo(!!soloMain);
      // prima si TOGLIE, poi si aggiunge: se si passa al pacchetto, i tre
      // separati devono essere gia' fuori quando entra il bundle.
      for (const [vid, q] of target) if (q === 0) carrello = await porta(carrello, vid, 0);
      for (const [vid, q] of target) if (q > 0) carrello = await porta(carrello, vid, q);
      ultimoCarrello = carrello;
      pingCarrello(cfg, carrello);
      return carrello;
    }

    function ridisegna() {
      bumpEls.forEach((el) => {
        const on = bundleOn || scelte.has(el.dataset.saigaBump);
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
        const box = el.querySelector('.k-upbox');
        if (box) box.textContent = on ? '✓' : '';
      });
      if (bundleEl) {
        bundleEl.classList.toggle('is-on', bundleOn);
        bundleEl.setAttribute('aria-checked', bundleOn ? 'true' : 'false');
        const box = bundleEl.querySelector('.k-upbox');
        if (box) box.textContent = bundleOn ? '✓' : '';
      }
      /* ⛔ 30/08 (sera) — IL TOTALE: PRIMA QUELLO CALCOLATO, POI QUELLO VERO.
         Prima si mostrava solo `ultimoCarrello.total_price`, cioe' il numero che
         torna da Shopify: finche' la rete non aveva risposto il totale restava
         quello di prima, e la spunta sembrava non aver fatto niente.
         Adesso: appena si clicca si mostra il totale calcolato dai prezzi che la
         section ha gia' messo in `cfg` (stessi centesimi, stessa formattazione);
         quando la risposta arriva vince LEI, perche' e' l'unica che conosce sconti
         automatici e conversioni di valuta. Se coincidono — ed e' il caso normale —
         l'occhio non vede nessun salto. */
      if (totEl) {
        var allineato = (versioneUI === versioneSincronizzata) && ultimoCarrello;
        totEl.textContent = soldi(allineato ? ultimoCarrello.total_price : totaleAtteso());
      }
    }

    /* Il totale che il carrello DEVE avere, date le spunte di adesso. Gli stessi
       centesimi che usa Shopify: `cfg` li ha presi da `product.price` in Liquid. */
    function totaleAtteso() {
      var c = (cfg.main && cfg.main.price) || 0;
      if (bundleOn && cfg.bundle) {
        c += cfg.bundle.price || 0;
      } else {
        (cfg.bumps || []).forEach(function (b) {
          if (scelte.has(b.key)) c += b.price || 0;
        });
      }
      return c;
    }

    /* ⛔ 30/08 (sera) — PERCHE' QUESTO NON E' PIU' UN "OCCUPATO, TORNA DOPO".
       La versione di prima faceva `if (occupato) return;` in cima al click: mentre
       una chiamata era in volo, i click successivi venivano **buttati via in
       silenzio**. Cliccando in fretta tre righe, la seconda e la terza non facevano
       niente e il carrello sembrava rotto o lentissimo.
       Adesso i click non si perdono mai: cambiano subito lo stato e disegnano subito
       la spunta, e la rete li insegue. Se arriva un click mentre una sincronizzazione
       e' in corso si alza `daRifare`, e appena finisce se ne fa un'altra sullo stato
       PIU' RECENTE — non su quello di quando era partita. Le chiamate si accorpano da
       sole: tre spunte veloci non fanno tre attese.
       ⛔ Regge la regola d'oro: `sincronizza` legge /cart.js e chiama add.js solo per
          le varianti che mancano, quindi `add_to_cart` resta UN evento per variante. */
    /* ⛔ IN INGLESE, e non e' un dettaglio di stile: questo testo lo legge il
       CLIENTE, e il mercato e' US/UK/AU. Il 29/08 in questo riquadro e' andato
       online un messaggio in italiano. Regola: dentro questo file, italiano
       SOLO nei commenti.
       ⚠️ Dopo un errore la spunta mostrata potrebbe non corrispondere al carrello
          vero: si rilegge /cart.js e si riallineano le spunte a quello che c'e'
          davvero. Meglio una spunta che salta indietro di una bugia silenziosa. */
    function mostraErrore(e) {
      errore('&#9888; We couldn&rsquo;t update your cart: ' + esc(e && e.message)
        + '. Please try again in a moment — you have not been sent to checkout.');
      leggiCarrello().then(function (c) {
        scelte.clear();
        bundleOn = !!(cfg.bundle && riga(c, cfg.bundle.variantId));
        if (!bundleOn) {
          (cfg.bumps || []).forEach(function (b) {
            if (riga(c, b.variantId)) scelte.add(b.key);
          });
        }
        versioneSincronizzata = versioneUI;
        ridisegna();
      }).catch(function () {});
    }

    var daRifare = false;
    var attesaCorrente = null;

    function programmaSync(soloMain) {
      if (occupato) { daRifare = true; return attesaCorrente; }
      attesaCorrente = (async function () {
        occupato = true;
        try {
          do {
            daRifare = false;
            errore('');
            var mia = versioneUI;
            await sincronizza(!!soloMain);
            versioneSincronizzata = mia;
            ridisegna();
          } while (daRifare);
        } catch (e) {
          mostraErrore(e);
        } finally {
          occupato = false;
          attesaCorrente = null;
        }
      })();
      return attesaCorrente;
    }

    /* Usata solo dai due bottoni che portano al checkout: li' l'attesa e' giusta,
       perche' non si manda nessuno al checkout con un carrello non allineato. */
    async function conAttesa(fn) {
      if (occupato) { try { await attesaCorrente; } catch (_) {} }
      occupato = true;
      if (goEl) goEl.disabled = true;
      try {
        errore('');
        var mia = versioneUI;
        await fn();
        versioneSincronizzata = mia;
        ridisegna();
      } catch (e) {
        mostraErrore(e);
      } finally {
        occupato = false;
        if (goEl) goEl.disabled = false;
      }
    }

    /* ⛔ 30/08/2026 — COSA SUCCEDE SE IL PRODOTTO PRINCIPALE NON C'E'.
       Prima: si apriva il carrello e al posto del checkout compariva un avviso
       IN ITALIANO, rivolto a chi amministra il negozio ma letto dai clienti. E'
       andato online cosi'. Adesso le due platee sono separate:
         · nell'editor del tema (designMode) l'avviso resta, in italiano, per
           Alessandro — li' non ci sono clienti;
         · in negozio il carrello NON si apre affatto. Il click cade sul link,
           che porta al catalogo: un percorso d'acquisto che funziona vale piu'
           di una finestra che spiega un problema di configurazione.
       Con gli handle di ripiego nella section questo ramo non dovrebbe mai
       scattare: e' la seconda rete, non la prima. */
    function apri(e) {
      if (nonConfigurato() && !cfg.designMode) {
        if (e && e.preventDefault) e.preventDefault();
        window.location.href = cfg.fallbackUrl || url('/collections/all');
        return;
      }
      if (e && e.preventDefault) e.preventDefault();
      document.body.style.overflow = 'hidden';
      wrap.hidden = false;
      if (nonConfigurato()) {
        errore('&#9881; <b>Solo nell\'editor:</b> manca il <b>Prodotto principale</b> '
          + 'nelle impostazioni del tema (Prodotti &rarr; handle). '
          + 'In negozio queste CTA portano al catalogo invece di aprire il carrello.');
        ridisegna();
        return;
      }
      // Il carrello si disegna SUBITO col totale di listino, poi la rete allinea.
      ridisegna();
      // ⛔ QUI si vince l'add-to-cart contato una volta sola: si legge cosa c'e'
      //    gia' nel carrello e add.js si chiama solo se la variante manca.
      programmaSync(false);
    }

    function chiudi() {
      document.body.style.overflow = '';
      wrap.hidden = true;
      errore('');
    }

    // spunta / de-spunta di un order bump
    bumpEls.forEach((el) => {
      const k = el.dataset.saigaBump;
      const tocca = () => {
        // ⛔ niente `if (occupato) return`: un click non si butta mai via.
        if (bundleOn) {
          // dal pacchetto si esce togliendo una voce: restano dentro le altre due
          bundleOn = false;
          scelte.clear();
          (cfg.bumps || []).forEach((b) => { if (b.key !== k) scelte.add(b.key); });
        } else {
          if (scelte.has(k)) scelte.delete(k); else scelte.add(k);
          // se le prende tutte e tre il pacchetto costa 6 € meno: non glielo si
          // fa pagare a prezzo pieno solo perche' ha cliccato tre volte
          if (cfg.bundle && (cfg.bumps || []).every((b) => scelte.has(b.key))) bundleOn = true;
        }
        // ⛔ PRIMA si disegna, POI si parla con la rete. E' tutta qui la differenza
        //    fra una spunta immediata e una che arriva mezzo secondo dopo.
        versioneUI += 1;
        ridisegna();
        programmaSync(false);
      };
      el.addEventListener('click', tocca);
      el.addEventListener('keydown', (ev) => {
        if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); tocca(); }
      });
    });

    if (bundleEl) {
      const tocca = () => {
        bundleOn = !bundleOn;
        scelte.clear();
        if (bundleOn) (cfg.bumps || []).forEach((b) => scelte.add(b.key));
        versioneUI += 1;
        ridisegna();
        programmaSync(false);
      };
      bundleEl.addEventListener('click', tocca);
      bundleEl.addEventListener('keydown', (ev) => {
        if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); tocca(); }
      });
    }

    /* 🔑 UN SOLO PASSO IN PIU' PRIMA DEL REDIRECT, ED E' QUELLO CHE SALVA IL PURCHASE.
       `sgTagCart()` (vive in snippets/meta-pixel.liquid) scrive _fbp, _fbc e
       l'external_id negli ATTRIBUTI NASCOSTI del carrello. Da li' finiscono
       nell'ordine, e il webhook orders/paid li restituisce al server: il Purchase
       parte da Shopify, non dal browser del cliente, e arriva a Meta GIA'
       ATTRIBUITO all'inserzione che l'ha pagata.
       ⛔ Togliere questa chiamata non rompe niente di visibile: il Purchase
          continua ad arrivare, ma SENZA _fbc. Le ads smettono di sapere quali
          vendite hanno prodotto, e non c'e' nessun errore da nessuna parte.
       ⛔ Non si aspetta piu' di 1,2 s: il checkout non si fa attendere, e un
          attributo mancante costa l'attribuzione di UNA vendita — un cliente
          fermo su un bottone che non risponde le costa tutte.
       ⛔ E si va al checkout ANCHE se sgTagCart non esiste (pixel spento) o va in
          errore: il tracciamento non deve mai poter impedire un acquisto. */
    const vaiAlCheckout = () => new Promise((risolvi) => {
      const dest = url('/checkout');
      let partito = false;
      const vai = () => {
        if (partito) return;
        partito = true;
        window.location.href = dest;
        risolvi();
      };
      const marca = (typeof window.sgTagCart === 'function') ? window.sgTagCart() : null;
      if (marca && typeof marca.then === 'function') {
        marca.then(vai, vai);
        setTimeout(vai, 1200);
      } else {
        vai();
      }
    });

    // "Continue to Checkout": si allinea il carrello alle spunte, POI si va.
    if (goEl) goEl.addEventListener('click', () => {
      if (nonConfigurato()) { apri(); return; }
      conAttesa(async () => {
        await sincronizza(false);
        await vaiAlCheckout();
      });
    });

    /* "No thanks, just the main product":
       ⛔ NON basta andare al checkout. Prima si TOLGONO dal carrello tutti i
          bump e il bundle (change.js quantity 0), poi si va a /checkout.
          Altrimenti chi ha spuntato qualcosa e poi ha cliccato "no grazie" se lo
          ritrova nell'ordine, e quello e' un addebito non voluto. Nel prototipo
          non succedeva solo perche' il permalink ricostruiva il carrello da zero. */
    const noEl = root.querySelector('[data-saiga-onlymain]');
    if (noEl) noEl.addEventListener('click', () => {
      if (nonConfigurato()) { apri(); return; }
      conAttesa(async () => {
        bundleOn = false;
        scelte.clear();
        await sincronizza(true);
        await vaiAlCheckout();
      });
    });

    root.querySelectorAll('[data-saiga-close]').forEach((b) => b.addEventListener('click', chiudi));
    wrap.addEventListener('click', (e) => { if (e.target === wrap) chiudi(); });

    return { apri, chiudi, chiuso: () => wrap.hidden };
  }

  /* Il popup vero e proprio. Ritorna null se non c'e' niente da montare.
     ⛔ NON si apre mentre il carrello e' aperto: coprirebbe il bottone di
        checkout. E' una necessita' meccanica, non una scelta di targeting. */
  function creaPopup(root, cfg, carrello) {
    const wrap = root.querySelector('[data-saiga-popup]');
    if (!wrap || !cfg.popup || !cfg.popup.on) return null;

    const form   = wrap.querySelector('[data-saiga-popsub]');
    const campo  = wrap.querySelector('input[type="email"]');
    const bott   = wrap.querySelector('[data-saiga-popgo]');
    const errEl  = wrap.querySelector('[data-saiga-poperr]');
    const zonaF  = wrap.querySelector('[data-saiga-popform]');
    const zonaOk = wrap.querySelector('[data-saiga-popok]');
    const codeEl = wrap.querySelector('[data-saiga-popcode]');
    const usaEl  = wrap.querySelector('[data-saiga-popuse]');
    const msgEl  = wrap.querySelector('[data-saiga-popmsg]');
    if (!form || !campo) return null;

    let aperto = false, finito = false, inVolo = false;

    const chiudi = () => {
      if (!aperto) return;
      aperto = false;
      wrap.hidden = true;
      wrap.setAttribute('aria-hidden', 'true');
      // ⛔ Si ripristina lo scorrimento SOLO se non e' il carrello a tenerlo
      //    bloccato: altrimenti chiudere il popup sbloccherebbe la pagina sotto
      //    un carrello ancora aperto.
      if (!carrello || carrello.chiuso()) document.body.style.overflow = '';
      MEM.scrivi(K_CHIUSO, String(Date.now()));
    };

    const apri = () => {
      if (aperto || finito) return;
      if (carrello && !carrello.chiuso()) return;   // mai sopra il carrello
      aperto = true;
      wrap.hidden = false;
      wrap.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      try { campo.focus({ preventScroll: true }); } catch (e) {}
    };

    const errore = (m) => {
      if (!errEl) return;
      errEl.textContent = m || '';
      errEl.hidden = !m;
    };

    /* Chi si e' gia' iscritto, o l'ha chiuso da meno di 30 giorni, non lo rivede. */
    const gia = () => {
      if (MEM.leggi(K_LEAD)) return true;
      const q = Number(MEM.leggi(K_CHIUSO) || 0);
      return !!q && (Date.now() - q) < GIORNI30;
    };

    const mostraCodice = (codice) => {
      finito = true;
      if (zonaF) zonaF.hidden = true;
      if (zonaOk) zonaOk.hidden = false;
      if (codice) {
        if (codeEl) codeEl.textContent = codice;
        /* Il link APPLICA il codice da solo: nessuno deve copiare e incollare
           niente. Ogni passaggio a mano e' gente che si perde per strada. */
        if (usaEl) usaEl.setAttribute('href', '/discount/' + encodeURIComponent(codice) + '?redirect=/');
      } else {
        /* Shopify non ha confermato il codice in tempo. ⛔ Non si inventa un
           codice e non si finge che sia andata male: l'iscrizione e' valida e il
           codice arriva per email. */
        if (codeEl) codeEl.style.display = 'none';
        if (msgEl) msgEl.textContent = 'Your code is on its way to your inbox.';
        if (usaEl) usaEl.setAttribute('href', '#buy');
      }
    };

    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      if (inVolo) return;
      const email = String(campo.value || '').trim();
      if (!email || email.indexOf('@') < 1 || email.length > 254) {
        errore('Please enter a valid email address.');
        try { campo.focus(); } catch (e) {}
        return;
      }
      errore('');
      inVolo = true;
      if (bott) { bott.disabled = true; bott.textContent = 'One moment...'; }

      let codice = null, andata = false;
      try {
        const r = await fetch(cfg.popup.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({
            email: email,
            u: window.location.href,
            fbp: (document.cookie.match(/(?:^|;\s*)_fbp=([^;]*)/) || [])[1] || '',
            fbc: (document.cookie.match(/(?:^|;\s*)_fbc=([^;]*)/) || [])[1] || '',
            xid: (document.cookie.match(/(?:^|;\s*)sg_xid=([^;]*)/) || [])[1] || ''
          })
        });
        if (r.ok) {
          const d = await r.json().catch(() => ({}));
          andata = !!d.ok;
          codice = d.code || null;
          if (d.id) MEM.scrivi(K_LEAD, d.id);
          if (codice) MEM.scrivi(K_CODICE, codice);
        }
      } catch (e) { /* rete: si tratta come "non andata" qui sotto */ }

      inVolo = false;
      if (!andata) {
        if (bott) { bott.disabled = false; bott.textContent = 'Send me the code'; }
        errore('That did not go through. Please try again in a moment.');
        return;
      }

      /* 🔑 L'evento Lead verso Meta: browser + server con lo STESSO event_id, e
         l'email che viaggia SOLO al server, che la hasha.
         ⛔ Dopo l'iscrizione, mai prima: un Lead sparato all'apertura del popup
            insegnerebbe a Meta a cercare gente che guarda i popup. */
      try {
        if (typeof window.sgTrack === 'function') {
          window.sgTrack('Lead', {
            content_name: 'popup-10',
            content_category: 'email-capture',
            currency: (cfg.currencyCode || 'USD'),
            value: 0
          }, { person: { em: email } });
        }
      } catch (e) {}

      mostraCodice(codice);
    });

    wrap.querySelectorAll('[data-saiga-popclose]').forEach((b) => b.addEventListener('click', chiudi));
    wrap.addEventListener('click', (e) => { if (e.target === wrap) chiudi(); });

    return { apri, chiudi, gia, chiuso: () => wrap.hidden };
  }

  /* ══ 3. IL MONTAGGIO DELLA PAGINA ══════════════════════════════════════════ */
  const istanze = new Map();

  function monta(root) {
    if (!root || root.dataset.saigaMontata === '1') return;
    const cfgEl = document.querySelector(
      '[data-saiga-config="' + root.dataset.saigaSection + '"]');
    if (!cfgEl) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.dataset.saigaMontata = '1';

    const A = cfg.assets || {};
    const img = (chiave) => A[chiave] || '';
    const ctx = { raf: null, osserva: null, onScroll: null, onEsc: null };
    const { nDesign, nPdf, nCollezioni, catalogue } = datiProdotto();

    // i numeri del prodotto, ovunque compaiano
    root.querySelectorAll('[data-saiga-ndesign]').forEach((e) => { e.textContent = nDesign; });
    root.querySelectorAll('[data-saiga-npdf]').forEach((e) => { e.textContent = nPdf; });

    /* — il carosello: cinque pezzi finiti, la lista ripetuta CINQUE volte.
         E' la ripetizione che rende il giro infinito senza un capo. */
    const track = root.querySelector('[data-saiga-track]');
    if (track) {
      const file = ['gallery/gallery-1', 'gallery/gallery-2', 'gallery/gallery-3',
                    'gallery/gallery-4', 'gallery/gallery-5'];
      let html = '';
      for (let c = 0; c < 5; c++) {
        file.forEach((f) => {
          html += '<div class="k-slide" style="background-image:url(' + esc(img(f)) + ')"></div>';
        });
      }
      track.innerHTML = html;
      montaCarosello(track, ctx);
    }

    // — la striscia dei quattro vantaggi
    const feat = root.querySelector('[data-saiga-features]');
    if (feat) {
      const features = [
        { icon: '🪡', title: 'No Sewing or Needle', desc: 'A foam board and a craft knife. That’s the toolkit.' },
        { icon: '♻️', title: 'Use Stash & Scraps', desc: 'Leftover fabric gets a second life.' },
        { icon: '⚡', title: 'Instant PDF Delivery', desc: 'Download at checkout. Start in 5 minutes.' },
        { icon: '🔢', title: 'Every Piece Numbered', desc: 'Numbered regions, a colour plan and a difficulty level.' },
      ];
      feat.innerHTML = features.map((f) => `
        <div class="k-feature" style="background:#fff;border:1px solid #EFE8DC;border-radius:16px;padding:24px;box-shadow:0 8px 24px rgba(0,0,0,.04)">
          <div style="width:46px;height:46px;border-radius:12px;background:#F3EEE5;display:flex;align-items:center;justify-content:center;font-size:22px">${f.icon}</div>
          <div style="font-size:16px;font-weight:700;margin:16px 0 5px">${esc(f.title)}</div>
          <div style="font-size:13.5px;color:#6a7079;line-height:1.5">${esc(f.desc)}</div>
        </div>`).join('');
    }

    // — i quattro passi del metodo
    const stepsEl = root.querySelector('[data-saiga-steps]');
    if (stepsEl) {
      const accent = getComputedStyle(root).getPropertyValue('--k-accent').trim() || '#C86D51';
      const stepData = [
        { n: 1, k: 'method-1', img: 'Printing the template', title: 'Pick & Print Your Template', desc: `Pick from ${nDesign} designs across ${nCollezioni} collections. Print at home.` },
        { n: 2, k: 'method-2', img: 'Choosing the palette', title: 'Select Your Color Palette', desc: 'Follow a palette, or match the fabric you already own.' },
        { n: 3, k: 'method-3', img: 'Tucking the fabric', title: 'Cut & Tuck', desc: 'Score the board along the grooves, tuck the fabric in.' },
        { n: 4, k: 'method-4', img: 'The framed piece', title: 'Frame & Display', desc: 'A finished piece for your wall, or a gift worth giving.' },
      ];
      stepsEl.innerHTML = stepData.map((s) => `
        <div class="k-card" style="background:#fff;border:1px solid #EFE8DC;border-radius:22px;padding:22px;box-shadow:0 18px 44px -28px rgba(30,36,43,.22)">
          <div style="position:relative;aspect-ratio:16/11;border-radius:16px;background:#F4F0E8 url(${esc(img(s.k))}) center/cover;border:1px solid #E7E0D4">
            <span style="position:absolute;left:12px;top:12px;background:rgba(30,36,43,.82);color:#F7F4EE;font-size:10.5px;letter-spacing:.09em;text-transform:uppercase;padding:5px 11px;border-radius:100px">Step ${s.n} &#183; ${esc(s.img)}</span>
          </div>
          <div style="display:flex;align-items:center;gap:11px;margin-top:18px">
            <span style="flex:none;width:32px;height:32px;border-radius:50%;background:${accent};color:#fff;display:flex;align-items:center;justify-content:center;font-family:'Cormorant Garamond',serif;font-size:17px;font-weight:600">${s.n}</span>
            <span style="font-size:17px;font-weight:700;color:#1E242B;line-height:1.2">${esc(s.title)}</span>
          </div>
          <p style="font-size:14px;line-height:1.55;color:#6a7079;margin-top:9px">${esc(s.desc)}</p>
        </div>`).join('');
    }

    /* — il filtro delle collezioni e la griglia dei template.
         8 card per collezione (4 colonne x 2 righe): la scelta la fa
         _aggiorna_catalogo.py, qui si disegna e basta. */
    const themesEl = root.querySelector('[data-saiga-themes]');
    const gridEl = root.querySelector('[data-saiga-tplgrid]');
    if (themesEl && gridEl) {
      const LV = ['', '●○○', '●●○', '●●●'];
      const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      const nomi = Object.keys(catalogue);
      let attivo = nomi.indexOf('Landscapes') >= 0 ? 'Landscapes' : nomi[0];

      themesEl.innerHTML = nomi.map((t) =>
        `<button type="button" class="k-themebtn" data-tema="${esc(t)}">${esc(t)}</button>`).join('');

      const disegna = () => {
        themesEl.querySelectorAll('.k-themebtn').forEach((b) => {
          b.classList.toggle('is-on', b.dataset.tema === attivo);
        });
        gridEl.innerHTML = (catalogue[attivo] || []).map((t) => `
          <div class="k-tplcard" style="border-radius:12px;overflow:hidden;border:1px solid #E7E0D4;background:#fff;box-shadow:0 6px 18px -12px rgba(30,36,43,.2)">
            <div style="aspect-ratio:1;background:#FBF9F5 url(${esc(img('templates/' + slug(t.n)))}) center/cover;border-bottom:1px solid #EFE8DC"></div>
            <div style="padding:10px 11px 12px">
              <div style="font-size:12px;font-weight:700;color:#1E242B;line-height:1.2">${esc(t.n)}</div>
              <div style="font-size:10.5px;letter-spacing:.03em;color:#A99E8C;margin-top:4px">${LV[t.d]}  ${t.p} pieces</div>
            </div>
          </div>`).join('');
      };
      themesEl.addEventListener('click', (e) => {
        const b = e.target.closest('.k-themebtn');
        if (!b) return;
        attivo = b.dataset.tema;
        disegna();
      });
      disegna();
    }

    // — il confronto a tre schede
    const cmpEl = root.querySelector('[data-saiga-compare]');
    if (cmpEl) {
      const accent = getComputedStyle(root).getPropertyValue('--k-accent').trim() || '#C86D51';
      const righe = [
        { metric: 'Learning Curve', kinu: 'Gentle', trad: 'Steep', pbn: 'Easy' },
        { metric: 'Equipment Cost', kinu: 'Minimal', trad: 'High', pbn: 'Medium' },
        { metric: 'Mess Level', kinu: 'None', trad: 'Threads & pins', pbn: 'Paint & water' },
        { metric: 'Time Required', kinu: 'Flexible', trad: 'Many hours', pbn: 'Hours' },
        { metric: 'Result Quality', kinu: 'Heirloom', trad: 'Varies', pbn: 'Flat / uniform' },
      ];
      const cols = [
        { key: 'kinu', name: 'Kinusaiga', tag: 'This collection', spicca: true },
        { key: 'trad', name: 'Sewing & Embroidery', tag: 'The traditional route', spicca: false },
        { key: 'pbn', name: 'Paint by Numbers', tag: 'The usual craft kit', spicca: false },
      ];
      cmpEl.innerHTML = cols.map((c) => `
        <div style="background:${c.spicca ? '#fff' : '#FCFAF6'};border:1px solid ${c.spicca ? accent : '#EFE8DC'};border-radius:22px;padding:26px 26px 20px;box-shadow:${c.spicca ? '0 26px 60px -32px rgba(200,109,81,.55)' : '0 16px 40px -30px rgba(30,36,43,.18)'}">
          <div style="display:inline-block;font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;padding:6px 12px;border-radius:100px;background:${c.spicca ? accent : '#F3EEE5'};color:${c.spicca ? '#fff' : '#8a8f96'}">${esc(c.tag)}</div>
          <div style="font-family:'Cormorant Garamond',serif;font-size:27px;font-weight:600;margin:14px 0 8px;color:${c.spicca ? '#1E242B' : '#6a7079'}">${esc(c.name)}</div>
          ${righe.map((r, i) => `
            <div style="display:flex;align-items:baseline;justify-content:space-between;gap:16px;padding:13px 0;${i ? 'border-top:1px solid #F0EAE0' : ''}">
              <span style="font-size:13.5px;color:#6a7079">${esc(r.metric)}</span>
              <span style="font-size:14.5px;font-weight:${c.spicca ? 700 : 500};text-align:right;color:${c.spicca ? '#4d6b4f' : '#6a7079'}">${esc(r[c.key])}</span>
            </div>`).join('')}
        </div>`).join('');
    }

    // — le FAQ (una aperta alla volta, la prima aperta all'inizio)
    const faqEl = root.querySelector('[data-saiga-faq]');
    if (faqEl) {
      const faqs = [
        { q: 'Do I need sewing experience or special equipment?', a: 'None at all. No stitching, no machine. Just a cheap foam board and a craft knife.' },
        { q: 'How is the product delivered?', a: `Instantly. You get an email with the full download the moment you check out — ${nPdf} template PDFs, the colour plans, the palettes and the guides.` },
        { q: 'What size paper do I need to print on?', a: 'Five sizes per design: a 7 and an 8 inch version on both A4 and US Letter, plus a 10 inch version on A3. Always print at 100%, never “fit to page”, or the finished piece comes out the wrong size. For the 8 inch designs use US Letter or A3 — on A4 the margin is only 3.4 mm.' },
        { q: 'Can I use fabric scraps I already have at home?', a: 'That’s the whole idea. The palettes help you match what’s already in your stash.' },
        { q: 'Is this a one-time payment or subscription?', a: 'One payment of ' + (cfg.priceText || (cfg.currency + cfg.salePrice)) + '. No subscription, no hidden fees. Yours forever.' },
      ];
      faqEl.innerHTML = faqs.map((f, i) => `
        <div class="k-faq${i === 0 ? ' is-open' : ''}" style="background:#fff;border:1px solid #EFE8DC;border-radius:14px;overflow:hidden;transition:.2s">
          <button type="button" style="width:100%;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:20px 24px;background:none;border:none;cursor:pointer;text-align:left;font-size:16.5px;font-weight:600;color:#1E242B;font-family:'Plus Jakarta Sans',sans-serif">
            ${esc(f.q)}<span class="k-faqicon">+</span>
          </button>
          <div class="k-faqans">${esc(f.a)}</div>
        </div>`).join('');
      faqEl.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b) return;
        const card = b.parentElement;
        const gia = card.classList.contains('is-open');
        faqEl.querySelectorAll('.k-faq').forEach((c) => c.classList.remove('is-open'));
        if (!gia) card.classList.add('is-open');
      });
    }

    // — la lista di spunte del riquadro finale
    const chkEl = root.querySelector('[data-saiga-checklist]');
    if (chkEl) {
      const voci = [
        `${nDesign} Kinusaiga designs across ${nCollezioni} collections`,
        `${nPdf} print-ready PDFs — 5 sizes, plain and numbered`,
        '3 in-depth Masterclass guides',
        '7 curator color palettes',
        `${nDesign} printable colour plans, one per design`,
        'Bonus: Material & Tools checklist',
        'Bonus: 10 Christmas patterns',
      ];
      chkEl.innerHTML = voci.map((c) =>
        `<div style="display:flex;align-items:center;gap:12px;font-size:15px;color:#eef1f4"><span style="color:#7B8C7C;font-weight:800">✓</span> ${esc(c)}</div>`).join('');
    }

    /* — la barra fissa.
       ⛔ 07/09: non piu' `scrollY > 900`, che era una soglia scelta a occhio su un
          layout che non esiste piu'. La regola adesso e' quella vera: la barra
          compare quando il BLOCCO OFFERTA e' uscito dallo schermo verso l'alto, e
          risparisce se ci si torna sopra. Cosi' non copre mai la CTA dell'offerta
          con una seconda CTA che dice la stessa cosa.
       Se `#buy` non c'e' (section modificata) si ricade sulla soglia vecchia. */
    const sticky = root.querySelector('[data-saiga-sticky]');
    if (sticky) {
      const buy = root.querySelector('#buy');
      /* ⛔ 07/09 (sera) — e si NASCONDE di nuovo sulla chiusura. In fondo alla pagina
         c'e' lo stesso blocco offerta su fondo navy: lasciare la barra li' significa
         coprire la CTA vera con una seconda CTA che dice la stessa cosa. */
      const chiusura = root.querySelector('.k-offerband--dark');
      let visto = false;
      ctx.onScroll = () => {
        const passato = buy ? (buy.getBoundingClientRect().bottom < 0)
                            : (window.scrollY > 900);
        const suChiusura = chiusura
          ? (chiusura.getBoundingClientRect().top < window.innerHeight - 80)
          : false;
        const show = passato && !suChiusura;
        if (show === visto) return;
        visto = show;
        sticky.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
      };
      window.addEventListener('scroll', ctx.onScroll, { passive: true });
      ctx.onScroll();
    }

    /* — le CTA "alte" (nav e hero) SCORRONO al blocco offerta, non aprono il
         carrello. Vedi il commento nella section: con tutte e cinque le CTA che
         aprivano il carrello, il visitatore aveva due stati soli.
       ⛔ `href="#buy"` resta e funziona da solo: questo handler serve solo a
          rispettare `prefers-reduced-motion` e a non sporcare la cronologia. */
    root.querySelectorAll('[data-saiga-scroll]').forEach((a) => {
      a.addEventListener('click', (e) => {
        const buy = root.querySelector('#buy');
        if (!buy) return;                       // niente ancora: il link fa il suo
        e.preventDefault();
        const lento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        buy.scrollIntoView({ behavior: lento ? 'auto' : 'smooth', block: 'start' });
      });
    });

    /* — i puntini del carosello dell'offerta.
       Lo scorrimento lo fa il CSS (scroll-snap): qui si illumina solo il puntino
       giusto. Se questo blocco non gira, il carosello si trascina lo stesso. */
    /* ⛔ 07/09 (sera): i caroselli dell'offerta sono DUE — quello in alto e quello
       della chiusura, che e' la stessa stringa Liquid stampata due volte. Con
       `querySelector` i puntini del secondo non si sarebbero mai accesi, e nessuno
       se ne sarebbe accorto guardando solo la cima della pagina. */
    const caroselli = Array.prototype.slice.call(root.querySelectorAll('[data-saiga-oslide]'));
    const puntiere = Array.prototype.slice.call(root.querySelectorAll('[data-saiga-odots]'));
    ctx.aggiornaOsl = [];
    caroselli.forEach((osl, idx) => {
      const odots = puntiere[idx];
      if (!odots) return;
      const punti = Array.prototype.slice.call(odots.children);
      const aggiorna = () => {
        const larghezza = osl.clientWidth || 1;
        const i = Math.max(0, Math.min(punti.length - 1,
          Math.round(osl.scrollLeft / larghezza)));
        punti.forEach((s, k) => s.classList.toggle('on', k === i));
      };
      osl.addEventListener('scroll', aggiorna, { passive: true });
      ctx.aggiornaOsl.push(aggiorna);
      aggiorna();
    });
    if (ctx.aggiornaOsl.length) {
      ctx.onResizeOsl = () => ctx.aggiornaOsl.forEach((f) => f());
      window.addEventListener('resize', ctx.onResizeOsl, { passive: true });
    }

    // — il carrello, e le CINQUE CTA che lo aprono
    //   (nav · hero · metodo · riquadro offerta · barra fissa)
    //   href="#buy" resta sotto come ripiego se il JS non parte.
    const carrello = creaCarrello(root, cfg);
    if (carrello) {
      root.querySelectorAll('[data-saiga-open]').forEach((a) => {
        a.addEventListener('click', carrello.apri);
      });
      ctx.onEsc = (e) => { if (e.key === 'Escape' && !carrello.chiuso()) carrello.chiudi(); };
      window.addEventListener('keydown', ctx.onEsc);

      /* — l'icona del carrello in alto a destra.
         Compare SOLO se il carrello ha qualcosa dentro: un'icona a zero e' un
         invito ad aprire una finestra vuota. Il conteggio si legge da /cart.js,
         quindi e' vero anche per chi torna con un carrello di una visita prima.
         ⛔ NON usa un contatore suo: il carrello di Shopify e' l'unica fonte.
            Un numero calcolato in pagina divergerebbe in silenzio dal checkout.
         ⛔ Nessun evento di tracciamento parte da qui: leggere /cart.js non e'
            un add_to_cart, e inventarne uno gonfierebbe i dati su cui si decide
            quanto spendere. */
      const fab = root.querySelector('[data-saiga-fab]');
      const fabn = root.querySelector('[data-saiga-fabn]');
      if (fab && fabn) {
        const routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        /* ⛔ L'icona si vede SEMPRE una volta scesi (richiesta di Alessandro: deve
           restare al posto dell'intestazione). E' il NUMERO a comparire solo quando
           c'e' davvero qualcosa dentro: un pallino con "0" e' rumore.
           ⛔ Unica eccezione, misurata guardando la pagina e non il codice: sulla
              CHIUSURA su fondo navy l'icona finiva sopra l'occhiello e ne mangiava
              la fine ("INSTANT DOWNLO|AD"). Li' la CTA vera e' a mezzo schermo, quindi
              l'icona non serve e si toglie di mezzo — stessa regola della barra fissa. */
        const chiusuraFab = root.querySelector('.k-offerband--dark');
        const mostra = () => {
          const suChiusura = chiusuraFab
            ? (chiusuraFab.getBoundingClientRect().top < window.innerHeight - 80)
            : false;
          fab.hidden = !(window.scrollY > 220) || suChiusura;
        };
        const rileggi = () => fetch(routes.replace(/\/$/, '') + '/cart.js',
                                   { headers: { 'Accept': 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .then((c) => {
            const n = c && typeof c.item_count === 'number' ? c.item_count : 0;
            fabn.textContent = String(n);
            fabn.hidden = n < 1;
            mostra();
          })
          .catch(() => { fabn.hidden = true; mostra(); });
        fab.addEventListener('click', carrello.apri);

        /* ⛔ 07/09 (sera) — la nav non e' piu' fissa, quindi l'icona non si aggancia
           piu' alla sua altezza: sta in alto a destra e basta (il `top` lo decide il
           CSS). Compare oltre i 220 px di scroll, cioe' quando l'intestazione se n'e'
           andata e il carrello ne prende il posto; sopra quella soglia la CTA della
           nav e' li' accanto, e due bottoni vicini sono un bottone in meno. */
        ctx.onScrollFab = mostra;
        window.addEventListener('scroll', ctx.onScrollFab, { passive: true });

        rileggi();
        /* Si rilegge quando la finestra del carrello si CHIUDE: e' l'unico momento
           in cui il conteggio puo' essere cambiato senza ricaricare la pagina.
           Un MutationObserver sull'attributo `hidden` invece di un aggancio dentro
           `creaCarrello`: cosi' le due parti restano indipendenti. */
        const wrapEl = root.querySelector('[data-saiga-cart]');
        if (wrapEl && window.MutationObserver) {
          let eraAperto = !wrapEl.hidden;
          ctx.osservaFab = new MutationObserver(() => {
            const aperto = !wrapEl.hidden;
            if (eraAperto && !aperto) rileggi();
            eraAperto = aperto;
          });
          ctx.osservaFab.observe(wrapEl, { attributes: true, attributeFilter: ['hidden'] });
        }
      }
    }

    /* ── il popup ────────────────────────────────────────────────────────────
       Il ritardo e' un'impostazione del tema (default 10 s) proprio perche' si
       possa alzare senza rifare lo zip: e' la leva da usare se dovesse
       interrompere gente che stava gia' leggendo l'offerta. */
    const popup = creaPopup(root, cfg, carrello);
    if (popup && !popup.gia() && !cfg.designMode) {
      const attesa = Math.max(3, Number((cfg.popup && cfg.popup.delay) || 10)) * 1000;
      ctx.timerPopup = window.setTimeout(popup.apri, attesa);
      ctx.onEscPop = (e) => { if (e.key === 'Escape' && !popup.chiuso()) popup.chiudi(); };
      window.addEventListener('keydown', ctx.onEscPop);
    }

    istanze.set(root, ctx);
  }

  function smonta(root) {
    const ctx = istanze.get(root);
    if (!ctx) return;
    if (ctx.raf) cancelAnimationFrame(ctx.raf);
    if (ctx.osserva) ctx.osserva.disconnect();
    if (ctx.osservaFab) ctx.osservaFab.disconnect();
    if (ctx.onResizeOsl) window.removeEventListener('resize', ctx.onResizeOsl);
    if (ctx.onScrollFab) window.removeEventListener('scroll', ctx.onScrollFab);
    if (ctx.onScroll) window.removeEventListener('scroll', ctx.onScroll);
    if (ctx.onEsc) window.removeEventListener('keydown', ctx.onEsc);
    if (ctx.onEscPop) window.removeEventListener('keydown', ctx.onEscPop);
    if (ctx.timerPopup) clearTimeout(ctx.timerPopup);
    document.body.style.overflow = '';
    istanze.delete(root);
    delete root.dataset.saigaMontata;
  }

  const tutte = () => document.querySelectorAll('[data-saiga-section]');

  function avvia() { tutte().forEach(monta); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  /* Il menu paese/valuta del piede invia da solo appena cambia. Delegato sul
     document, cosi' vale anche dopo un ri-render dell'editor del tema.
     ⛔ Senza JavaScript resta il bottone dentro il <noscript>: il cambio valuta
        non dipende da questo file. */
  document.addEventListener('change', (e) => {
    const sel = e.target && e.target.closest ? e.target.closest('[data-saiga-country]') : null;
    if (sel && sel.form) sel.form.submit();
  });

  /* ⚠️ L'editor del tema ri-renderizza l'HTML nel DOM SENZA ricaricare la pagina,
     e il JavaScript del caricamento NON viene rieseguito. Senza questi due
     agganci, dentro l'editor la pagina apparirebbe morta e sembrerebbe rotta. */
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector
      ? (e.target.matches('[data-saiga-section]') ? e.target
         : e.target.querySelector('[data-saiga-section]'))
      : null;
    if (root) monta(root);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector
      ? (e.target.matches('[data-saiga-section]') ? e.target
         : e.target.querySelector('[data-saiga-section]'))
      : null;
    if (root) smonta(root);
  });
})();
